import { permission_groups_to_exclude } from 'src/constants';

export interface DocTypeFilterOptions {
  excludeAll?: boolean;
  activeOnly?: boolean;
  excludeByKey?: string | string[];
}

/**
 * Filters out excluded doc types from store-shaped arrays.
 * Supports both `document_name` and `name` fields for flexibility.
 */
export function filterStoreDocTypes<T extends Record<string, any>>(
  items: T[] | null | undefined,
  options?: DocTypeFilterOptions,
): T[] {
  let result = (items || []).filter((item) => {
    const name = item.document_name ?? item.name;
    return !permission_groups_to_exclude.includes(name);
  });
  if (options?.excludeAll) {
    const getName = (item: T) => item.document_name ?? item.name ?? item.value;
    result = result.filter((item) => getName(item) !== 'all' && item.value !== 'all');
  }
  return result;
}

/**
 * Filters out excluded doc types from API-shaped arrays.
 * Supports both `document_name` (API responses) and `name` (dropdown items) fields.
 */
export function filterApiDocTypes<T extends Record<string, any>>(
  items: T[] | null | undefined,
  options?: DocTypeFilterOptions,
): T[] {
  let result = (items || []).filter((item) => {
    const name = item.document_name ?? item.name;
    return !permission_groups_to_exclude.includes(name);
  });
  if (options?.activeOnly) {
    result = result.filter((item) => item.is_active !== false);
  }
  if (options?.excludeByKey) {
    const keys = Array.isArray(options.excludeByKey) ? options.excludeByKey : [options.excludeByKey];
    result = result.filter((item) => !item.document_key || !keys.includes(item.document_key));
  }
  return result;
}
